import { defineMessages } from 'react-intl';

export default defineMessages({
  subscriptionSnackbarMVSubscriptionDeactivated: {
    defaultMessage: 'Your recurring payment for Mobile Video subscription has been deactivated.',
    description: 'Subscription snackbar - Your recurring payment for Mobile Video subscription has been deactivated',
    id: 'subscriptionSnackbarMVSubscriptionDeactivated',
  },
});
